import { client as client0 } from "../support/graphqlApi";
import config from "../config/settings";
import { tradesSubscription } from "./mutations";
const client = client0();
const isDevelopment = config.isDevelopment;

const channelToSubscription = new Map();

function handleData(trades, symbol) {
  const inUSD = true;
  if (isDevelopment) console.log("[socket] Message:", trades);
  if (!trades?.price) return;

  const { price, amountToken, amountNative, amountUSD, timestamp } = trades;

  const subscriptionItem = channelToSubscription.get(symbol);
  if (subscriptionItem === undefined) {
    return;
  }
  const tradePrice = parseFloat(price);
  const lastBar = subscriptionItem.lastBar;

  const resolutionPeriodLength = getResolutionLength(
    subscriptionItem.resolution
  );
  let tradeTime = timestamp - (timestamp % resolutionPeriodLength);

  const formatFloats = (num) => num; //toPrecision(7);
  let bar = [];
  if (tradeTime >= lastBar.time + resolutionPeriodLength) {
    bar = {
      time: tradeTime,
      open: lastBar.close,
      high: formatFloats(tradePrice),
      low: formatFloats(tradePrice),
      close: formatFloats(tradePrice),
      volume: parseFloat(amountUSD),
    };
  } else {
    bar = {
      ...lastBar,
      close: formatFloats(tradePrice),
      volume: lastBar.volume + parseFloat(amountUSD),
      high: Math.max(lastBar.high, formatFloats(tradePrice)),
      low: Math.max(lastBar.low, formatFloats(tradePrice)),
    };
  }

  subscriptionItem.lastBar = bar;
  subscriptionItem.handlers.forEach((handler) => handler.callback(bar));
}
export const getResolutionLength = (resolution) => {
  let seconds = 60;
  let amount;

  if (
    resolution.includes("D") ||
    resolution.includes("W") ||
    resolution.includes("S")
  ) {
    const unit = resolution.split("")[resolution.length - 1];
    amount =
      resolution.length > 1
        ? Number(
            resolution
              .split("")
              .splice(0, resolution.length - 1)
              .join("")
          )
        : 1;

    switch (unit) {
      case "S":
        seconds = 1;
        break;
      case "D":
        seconds = 86400;
        break;

      case "W":
        seconds = 604800;
        break;
      default:
        throw new Error("invalid interval");
    }
  } else amount = Number(resolution);

  return seconds * amount * 1000;
};

export async function subscribeOnStream(
  symbolInfo,
  resolution,
  onRealtimeCallback,
  subscribeUID,
  onResetCacheNeededCallback,
  lastBar
) {
  const handler = {
    id: subscribeUID,
    callback: onRealtimeCallback,
  };
  let subscriptionItem = channelToSubscription.get(symbolInfo.symbol);
  if (subscriptionItem) {
    // already subscribed to the channel, use the existing subscription
    subscriptionItem.handlers.push(handler);
    return;
  }
  subscriptionItem = {
    subscribeUID,
    resolution,
    lastBar,
    handlers: [handler],
  };
  channelToSubscription.set(symbolInfo.pair, subscriptionItem);
  console.log(
    "[subscribeBars]: Subscribe to streaming. Channel:",
    symbolInfo.pair
  );

  let sub = await client
    .subscription(
      tradesSubscription,
      {
        pair: symbolInfo.symbol,
      },
      { requestPolicy: "network-only" }
    )
    .subscribe((data) => {
      try {
        handleData(data.data.trades, symbolInfo.pair);
      } catch (e) {
        console.error(e);
      }
    });
  channelToSubscription.set(symbolInfo.pair, {
    ...subscriptionItem,
    unsubscribe: sub.unsubscribe,
  });
}

export function unsubscribeFromStream(subscriberUID) {
  // find a subscription with id === subscriberUID
  for (const channelString of channelToSubscription.keys()) {
    const subscriptionItem = channelToSubscription.get(channelString);
    const handlerIndex = subscriptionItem.handlers.findIndex(
      (handler) => handler.id === subscriberUID
    );

    if (handlerIndex !== -1) {
      // remove from handlers
      subscriptionItem.handlers.splice(handlerIndex, 1);

      if (subscriptionItem.handlers.length === 0) {
        // unsubscribe from the channel, if it was the last handler
        console.log(
          "[unsubscribeBars]: Unsubscribe from streaming. Channel:",
          channelString
        );

        let unsub = channelToSubscription.get(channelString);
        unsub.unsubscribe();
        channelToSubscription.delete(unsub);
        break;
      }
    }
  }
}
